export class NewsUrl {
  static newsUrl = '/news';
}
